// extracted by mini-css-extract-plugin
export var content = "_t1-1";
export var wrapper = "_t1-0";